export const ALLOWED_DOMAINS = {
	ALLOW_ALL: 1,
	CUSTOM_LIST: 2
}
